import { useMemo } from 'react';

import parse from 'html-react-parser';
import Image from 'next/image';

import { MetaHeaderSingleItemUnion } from '~/features/navigation/components/N21MetaHeader/types';
import { Sprite } from '~/features/sprites/components/Sprite/Sprite';
import type { IUspMetaMenuItem } from '~/lib/data-contract/auto-generated/api-model';
import { Icon } from '~/shared/components/Icon/Icon';

import styles from './metaHeaderItems.module.css';

export const useUSPItemContent = (item: MetaHeaderSingleItemUnion) => {
	const parsedRichText = useMemo(() => parse(item.richText?.html || ''), [item.richText?.html]);

	const iconElement = (item as IUspMetaMenuItem).showELabelAsIcon ? (
		<Icon
			className={styles.icon}
			size="sm"
			label="E-mærket"
		>
			<Image
				src="/assets/logos-external/e-maerket-06.svg"
				width={20}
				height={20}
				style={{ width: '20px', height: '20px' }}
				alt="E-mærket"
			/>
		</Icon>
	) : (item as IUspMetaMenuItem).icon ? (
		<Icon
			className={styles.icon}
			size="sm"
			label={(item as IUspMetaMenuItem).icon}
		>
			<Sprite name={(item as IUspMetaMenuItem).icon} />
		</Icon>
	) : null;

	return { iconElement, parsedRichText };
};
